module.exports = __webpack_public_path__ + "static/media/header-network-hecoModal.f0a306d1.svg";